export default __webpack_public_path__ + "static/media/White-pdf.70667a88.svg";